import React, { Component } from "react";
import { isNullOrUndefined } from "../../helpers/validation";
import SearchResponse from "../../services/api/interfaces/SearchResponse";
import { ApiResponse } from "../../services/api/interfaces/ApiResponse";
import ResponseHandler from "services/api/handler/ResponseHandler";

type ProcessResponseMapping = {
  origin?: string;
  destination: string;
};

type ProcessResponseOptions = {
  mappings?: Array<ProcessResponseMapping> | ProcessResponseMapping;
  paginate?: {
    destination: string;
  };
  keepFetching?: boolean;
};

export interface BaseContextState {
  fetching?: boolean;
  success?: boolean;
  code?: number;
  error?: any;
  pagination?: SearchResponse<any>;
}

// Fixes stringified properties
const fixJsonProps = (data: any) => {
  Object.keys(data).forEach((key) => {
    try {
      if (typeof data[key] === "string") {
        data[key] = JSON.parse(data[key]);
      }
    } catch (err) {}
  });

  return data;
};

export class BaseContextProvider extends Component {
  state: BaseContextState = {
    fetching: false,
    success: false,
  };

  /**
   * Reset errors from context
   */
  resetErrors = () => {
    this.setState({
      error: null,
    });
  };

  /**
   * Process every response of this provider
   *
   * @param {ApiResponse<any>} response
   * @param {Array<string>} fields
   */
  processResponse = async (
    response: ApiResponse<any>,
    options: ProcessResponseOptions = {}
  ) => {
    const { ok, problem } = response;
    let newState = Object.assign({}, this.state);
    newState.fetching = options.keepFetching || false;
    newState.error = null;
    
    try {
      if (response.data?.status && response.data?.prefix) {
        const handler = ResponseHandler(
          response.data.status,
          response.data.prefix
        );
        handler(response, null);
      }
    } catch (e) {
      console.log("error",e);
    }

    if(Array.isArray(response.data)){
      newState.success = true;
      newState.fetching = false;
      this.setState(newState);
      return response
    }

    //console.log(handler)

    /*if (response.data) {
      newState.code = response.data.code
      newState.error = response.data.message
    }*/
    //TODO

    // Something went wrong
    if (!ok || response.data?.prefix !== "2xx") {
      newState.success = false;
      newState.fetching = false;
      newState.error = problem || response.data?.message;

      this.setState(newState);
      return newState;
    }

    if (ok && response.data.status !== 200) {
      newState.success = false;
      newState.fetching = false;

      if (response.data?.data) {
        newState.error = response.data?.data;
      }


      this.setState(newState);
      return newState;
    }

    // By here we can check that the request was completed
    newState.success = true;

    // Does the API has returned something useful?
    if (!isNullOrUndefined(response.data?.data)) {
      let mapped = {} as any;
      const { data } = response.data;

      // Pagination settings
      if (options.paginate && data) {
        newState.pagination = {
          count: data.count,
          global_count: data.global_count,
          limit: data.limit,
          offset: data.offset,
          page: data.page,
          pages: data.pages,
        };

        mapped[options.paginate.destination] =
          data.result instanceof Array
            ? data.result.map((result) => fixJsonProps(result))
            : data.result;

        newState = {
          ...newState,
          ...mapped,
        };
      }

      // Mappings
      if (options.mappings) {
        if (options.mappings instanceof Array) {
          options.mappings.forEach((mapping) => {
            console.log(`Mapping`, mapping)
            const { origin, destination } = mapping;

            if (origin) {
              if (data[origin]) {
                mapped[destination] = data.result
                  ? fixJsonProps(data.result)
                  : fixJsonProps(data[origin]);
              }
            }
          });
        } else {
          const { origin, destination } = options.mappings;

          if (origin) {
            if (typeof data[origin] !== "undefined") {
              mapped[destination] = data.result
                ? fixJsonProps(data.result)
                : fixJsonProps(data[origin]);
            }
          } else {
            mapped[destination] = fixJsonProps(data);
          }
        }

        newState = {
          ...newState,
          ...mapped,
        };
      }
    }

    // Update our provider component)
    this.setState(newState);
    return newState;
  };

  render() {
    return <>{this.props.children}</>;
  }
}
